import { render, staticRenderFns } from "./Scoreboard.vue?vue&type=template&id=6788ded6&scoped=true&"
import script from "./Scoreboard.vue?vue&type=script&lang=js&"
export * from "./Scoreboard.vue?vue&type=script&lang=js&"
import style0 from "./Scoreboard.vue?vue&type=style&index=0&id=6788ded6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6788ded6",
  null
  
)

export default component.exports